module.exports = __webpack_public_path__ + "media/images/cover/bed-house-aedede1ea5efb2e8b955e8706ec0a216.jpeg";